var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"success"}},[_vm._v(" Questa azione è stata completata il "+_vm._s(_vm.completeDate)+" alle "+_vm._s(_vm.completeTime)+". ")])}
var staticRenderFns = []

export { render, staticRenderFns }